import React from 'react';
import { Phone, Star, Shield, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { whatsappNumber } from '../data/mock';
import BookingSearch from './BookingSearch';

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Luxury chauffeur service"
          width="1920"
          height="1080"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/70"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-amber-500/20 border border-amber-500/30 rounded-full px-4 py-2 mb-6 backdrop-blur-sm">
            <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
            <span className="text-amber-100 text-sm font-medium">{t('hero.badge')}</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight max-w-3xl">
            {t('hero.title')} <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">{t('hero.titleHighlight')}</span> {t('hero.titleEnd')}
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed max-w-3xl">
            {t('hero.subtitle')}
          </p>

          {/* Trust Indicators */}
          <div className="grid grid-cols-3 gap-4 mb-12 max-w-xl">
            <div className="flex items-center space-x-2">
              <Shield className="w-5 h-5 text-amber-400" />
              <span className="text-gray-300 text-sm">{t('hero.trustBadge1')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Clock className="w-5 h-5 text-amber-400" />
              <span className="text-gray-300 text-sm">{t('hero.trustBadge2')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Star className="w-5 h-5 text-amber-400 fill-amber-400" />
              <span className="text-gray-300 text-sm">{t('hero.trustBadge3')}</span>
            </div>
          </div>

          {/* Booking Search Form */}
          <BookingSearch />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-gray-400 text-sm">{t('hero.scrollText')}</span>
          <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-amber-400 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
